import { Injectable } from '@angular/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export interface HapticsOptions {
  style?: ImpactStyle;
}

@Injectable({
  providedIn: 'root',
})
export class HapticsService {
  private isSupported: boolean = false;

  constructor() {
    this.checkHapticsSupport();
  }

  /**
   * Checks if haptics are supported on the current device
   */
  private async checkHapticsSupport(): Promise<void> {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      this.isSupported = true;
    } catch (error) {
      this.isSupported = false;
      console.warn('Haptics not supported on this device:', error);
    }
  }

  /**
   * Triggers a light haptic impact
   * @param options Optional haptics configuration
   */
  public async lightImpact(): Promise<void> {
    if (!this.isSupported) return;

    try {
      await Haptics.impact({
        style: ImpactStyle.Light,
      });
    } catch (error) {
      console.warn('Failed to trigger light haptic impact:', error);
    }
  }

  /**
   * Triggers a medium haptic impact
   * @param options Optional haptics configuration
   */
  public async mediumImpact(): Promise<void> {
    if (!this.isSupported) return;

    try {
      await Haptics.impact({
        style: ImpactStyle.Medium,
      });
    } catch (error) {
      console.warn('Failed to trigger medium haptic impact:', error);
    }
  }

  /**
   * Triggers a heavy haptic impact
   * @param options Optional haptics configuration
   */
  public async heavyImpact(): Promise<void> {
    if (!this.isSupported) return;

    try {
      await Haptics.impact({
        style: ImpactStyle.Heavy,
      });
    } catch (error) {
      console.warn('Failed to trigger heavy haptic impact:', error);
    }
  }

  /**
   * Checks if haptics are supported on the current device
   * @returns boolean indicating if haptics are supported
   */
  public isHapticsSupported(): boolean {
    return this.isSupported;
  }

}
